"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "abbiategrasso": {
    "35512132": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "skipSearch": false
    }],
    "canova-di-sopra": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "74e2ac4c": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "skipSearch": false
    }],
    "case-rurali": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6e1c2da": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "skipSearch": false
    }],
    "cavallotta": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7de968bb": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "skipSearch": false
    }],
    "meraviglia": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ed06df92": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "skipSearch": false
    }],
    "nuova-bassano": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5bb5cbe7": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "skipSearch": false
    }],
    "san-donato": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d044138d": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "skipSearch": false
    }],
    "scocca": [{
      "hkey": "8f855057",
      "slug": "abbiategrasso",
      "name": "Abbiategrasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;